export default {"src":"/_next/static/media/reviewsio-logo.9e893213.svg","height":19,"width":119,"blurWidth":0,"blurHeight":0};